/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Services_Svc_Money_Art_2_LabelInputs */

const en_services_svc_money_art_2_label = /** @type {(inputs: Services_Svc_Money_Art_2_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Researched and scored`)
};

const lv_services_svc_money_art_2_label = /** @type {(inputs: Services_Svc_Money_Art_2_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Izpētīts un novērtēts`)
};

/**
* | output |
* | --- |
* | "Researched and scored" |
*
* @param {Services_Svc_Money_Art_2_LabelInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const services_svc_money_art_2_label = /** @type {((inputs?: Services_Svc_Money_Art_2_LabelInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Services_Svc_Money_Art_2_LabelInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_services_svc_money_art_2_label(inputs)
	return en_services_svc_money_art_2_label(inputs)
});